var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L2.14362 8V24L16 32L29.8564 24V8L16 0ZM22.4595 5.89444L11.4156 12.2706L9.54055 11.1881L20.5844 4.81187L22.4595 5.89444ZM10.4781 13.8944V19.1881L8.60305 18.1056V12.8119L10.4781 13.8944ZM16 2.16506L18.7094 3.72937L7.66555 10.1056L4.95612 8.54125L16 2.16506ZM15.0625 29.2937L4.01862 22.9175V10.1651L6.72805 11.7294V19.1881L12.3531 22.4357V14.977L15.0625 16.5413V29.2937ZM13.2905 13.3532L24.3344 6.977L27.0439 8.54131L16 14.9175L13.2905 13.3532ZM27.9814 22.9175L16.9375 29.2937V16.5413L27.9814 10.1651V22.9175Z",
    fill: "#8E918F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/Products.740a6c11524a836e81430e4982834e6e.svg";
export { ForwardRef as ReactComponent };